import React, { Component } from 'react';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  Row,
  Col
} from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
import './Register.css';
import { Auth } from 'aws-amplify';
import EstimatorNavBar from '../components/EstimatorNavBar';
import { CountryDropdown } from 'react-country-region-selector';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import $ from 'jquery';
import axios from 'axios';

export default class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captchaSolved: false,
      isLoading: false,
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      jobtitle: '',
      company: '',
      country: '',
      telephone: '',
      whyinterested: '',
      confirmationCode: '',
      newUser: null
    };
  }

  renderErrorString() {
    const c1 = this.state.name.length <= 0 ? <li>Name Required</li> : null;
    const c2 = this.state.email.length <= 0 ? <li>Email Required</li> : null;
    const c3 =
      this.state.password.length < 8 ? <li>Password Required</li> : null;
    const c4 =
      this.state.password !== this.state.confirmPassword ? (
        <li>Passwords do not match</li>
      ) : null;
    const c5 =
      this.state.jobtitle.length <= 0 ? <li>Job Title Required</li> : null;
    const c6 =
      this.state.company.length <= 0 ? <li>Company Required</li> : null;
    const c7 =
      this.state.country.length <= 0 ? <li>Country Required</li> : null;
    const c8 = !this.state.captchaSolved ? <li>Captcha not solved</li> : null;
    return (
      <ul className="error-string">
        {c1}
        {c2}
        {c3}
        {c4}
        {c5}
        {c6}
        {c7}
        {c8}
      </ul>
    );
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length >= 8 &&
      this.state.password === this.state.confirmPassword &&
      this.state.name.length > 0 &&
      this.state.jobtitle.length > 0 &&
      this.state.company.length > 0 &&
      this.state.country.length > 0 &&
      this.state.captchaSolved === true
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleCountrySelect(val) {
    this.setState({ country: val });
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      const newUser = await Auth.signUp({
        username: this.state.email,
        password: this.state.password,
        attributes: {
          'custom:name': this.state.name,
          'custom:jobtitle': this.state.jobtitle,
          'custom:company': this.state.company,
          'custom:country': this.state.country,
          'custom:telephone': this.state.telephone,
          'custom:whyinterested': this.state.whyinterested
        }
      });

      //mailchimp
      try {
        /* const response = */ await axios.post(
          'https://r6jjaxw9re.execute-api.eu-west-2.amazonaws.com/prod/va-estimator/subscribe',
          JSON.stringify({
            email_address: this.state.email,
            name: this.state.name,
            telephone: this.state.telephone
          })
        );
        /* console.log(response); */
      } catch (err) {
        console.error(err);
      }

      this.setState({
        newUser
      });
    } catch (e) {
      alert(e.message);
    }

    this.setState({ isLoading: false });
    window.scrollTo(0, 0);
  };

  resendEmail(e) {
    e.preventDefault();
    Auth.resendSignUp(this.state.email);
    $('#resend-button').prop('disabled', true);
    setTimeout(function() {
      $('#resend-button').prop('disabled', false);
    }, 5000);
  }

  handleConfirmationSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
      await Auth.signIn(this.state.email, this.state.password);

      this.props.userHasAuthenticated(true);
      this.props.history.push('/');
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  };
  onCaptchaChange = event => {
    this.setState({ captchaSolved: true });
  };

  renderConfirmationForm() {
    return (
      <Col xs={12} md={12}>
        <Row>
          <p>
            A confirmation email has been sent to the email address you signed
            up with. Please click the link inside in order to finish validating
            your account. Remember to check your spam or junk mail folder.
          </p>
          <p>
            Once you have validated your account, please{' '}
            <Link to="/login">login</Link> to continue.
          </p>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Button
              id="resend-button"
              bsSize="large"
              className="btn-block"
              onClick={e => this.resendEmail(e)}>
              Resend Email
            </Button>
          </Col>
          <Col xs={12} md={8} />
        </Row>
      </Col>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="name" bsSize="large">
          <ControlLabel>Name *</ControlLabel>
          <FormControl
            autoFocus
            type="text"
            value={this.state.name}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email *</ControlLabel>
          <FormControl
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Password *</ControlLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
          />
          <p>
            Min. 8 characters with at least 1 number, 1 uppercase letter and 1
            lowercase letter
          </p>
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <ControlLabel>Confirm Password *</ControlLabel>
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <FormGroup controlId="jobtitle" bsSize="large">
          <ControlLabel>Job Title *</ControlLabel>
          <FormControl
            type="text"
            value={this.state.jobtitle}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="company" bsSize="large">
          <ControlLabel>Company *</ControlLabel>
          <FormControl
            type="text"
            value={this.state.company}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="country" bsSize="large">
          <ControlLabel>Country *</ControlLabel>
          {/* <FormControl
            type="text"
            value={this.state.country}
            onChange={this.handleChange}
          /> */}
          <CountryDropdown
            value={this.state.country}
            onChange={val => this.handleCountrySelect(val)}
          />
        </FormGroup>
        <FormGroup controlId="telephone" bsSize="large">
          <ControlLabel>Telephone</ControlLabel>
          <FormControl
            type="tel"
            value={this.state.telephone}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="whyinterested" bsSize="large">
          <ControlLabel>Why are you interested in our VAPE?</ControlLabel>
          <FormControl
            componentClass="textarea"
            value={this.state.whyinterested}
            onChange={this.handleChange}
          />
        </FormGroup>
        <div className="recaptcha-container">
          <ReCAPTCHA
            ref="recaptcha"
            sitekey="6LdQy10UAAAAAK1t5zimrgR4osYqoJWZeEOvGiXD"
            onChange={this.onCaptchaChange}
          />
        </div>
        <p>
          Please be aware that we will be processing your input data in
          accordance with our{' '}
          <a
            href="http://digimasters.co.uk/privacy-cookies-policy.php"
            target="_blank"
            rel="noopener noreferrer">
            privacy policy
          </a>
          . By registering you agree to be contacted by us with regards to
          updates and releases of the estimator.
        </p>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Register"
          loadingText="Registering…"
        />
        {this.renderErrorString()}
      </form>
    );
  }

  render() {
    return (
      <div>
        <EstimatorNavBar
          isAuthenticated={this.props.isAuthenticated}
          appLogout={this.props.appLogout}
        />
        <div className="Register">
          {this.state.newUser === null
            ? this.renderForm()
            : this.renderConfirmationForm()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Register.js